import { Injectable, Injector } from "@angular/core";
import { ModuleService } from "./ModuleService";

export interface ComputerData {
  ComputerName: string;
  KioskName: string;
  KioskNameUnitName: string;
  LocationID: string;
  UnitName: string;
}
const defaultComputerData: ComputerData = {
  ComputerName: "",
  KioskName: "",
  KioskNameUnitName: "",
  LocationID: "",
  UnitName: "",
}

@Injectable({
  providedIn: 'root'
})
export class CPUModuleService extends ModuleService {
  _cache?: ComputerData;

  constructor(public injector: Injector) {
    super("CPU", injector)
    this.logger.log('CPU constructor')
  }

  public getComputerData(): Promise<ComputerData> {
    return new Promise((resolve, reject) => {
      if (this._cache) {
        resolve(this._cache)
      } else {
        this.callMethod('CPU_GetComputerData').then((data: ComputerData) => {
          this._cache = data;
        }).catch((e: any) => {
          this.logger.log('error getting cpu info', e)
          this._cache = defaultComputerData
        }).finally(() => {
          resolve(this._cache || defaultComputerData)
        })
      }
    })
  }

  public getName(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.config.KIOSK_ENABLED) resolve('')
      this.getComputerData().then((data: ComputerData) => {
        resolve(data.KioskName)
      }).catch(() => {
        resolve("")
      })
    })
  }

}
